<template>
	<div class="vee-table">
		<gc-table :showPage="false" border :columns="columns" :table-data="tableData"></gc-table>
		<!-- 修改弹窗 -->
		<gc-dialog
			:show.sync="dialogShow"
			:width="ruleForm.alarmSource === 1 || ruleForm.comparisonName ? '550px' : '850px'"
			@cancel="handleCancel"
			@close="handleCancel"
			@ok="handleSubmitForm"
			title="修改规则"
		>
			<el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="top">
				<el-form-item label="功能名称" prop="eventName">
					<el-input v-model="ruleForm.eventName" disabled></el-input>
				</el-form-item>
				<el-form-item
					label="状态"
					prop="state"
					:rules="[ruleRequired('选择规则状态')]"
					style="margin-bottom: 0"
				>
					<el-radio-group v-model="ruleForm.state">
						<el-radio label="1">启用</el-radio>
						<el-radio label="0">停用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item
					v-if="ruleForm.alarmSource === 2 && ruleForm.comparisonName"
					:label="ruleForm.comparisonName"
					prop="comparisonValue"
					key="comparisonValue"
					:rules="[
						ruleRequired('请输入'),
						!isBlank(ruleForm.comparisonValueReg)
							? {
									pattern: ruleForm.comparisonValueReg,
									message: !isBlank(ruleForm.comparisonValueRegMsg)
										? ruleForm.comparisonValueRegMsg
										: '',
									trigger: 'change',
							  }
							: '',
					]"
				>
					<el-input
						v-model="ruleForm.comparisonValue"
						placeholder="请输入"
						:disabled="ruleForm.state === '0'"
					></el-input>
				</el-form-item>
				<AlarmConfigRule
					v-if="ruleForm.alarmSource === 2 && !ruleForm.comparisonName"
					ref="alarmConfigRule"
					:deviceTypeId="tabData.deviceTypeId"
					:disabled="ruleForm.state === '0'"
					:eventExpression="ruleForm.eventExpression"
				/>
			</el-form>
		</gc-dialog>
	</div>
</template>

<script>
import { isBlank } from '@/utils/validate'
import { ruleRequired } from '@/utils/rules'
import { apiGetVeeRuleConfig, apiSetVeeRuleConfig } from '@/apis/account.api'
import AlarmConfigRule from '@/pages/alarm-config/param/components/AlarmConfigRule.vue'
export default {
	name: 'VeeRule',
	components: { AlarmConfigRule },
	props: {
		tabData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			tableData: [],
			columns: [
				{
					key: 'eventName',
					name: '功能名称',
				},
				{
					key: 'alarmSource',
					name: '告警来源',
					render: (h, row) => {
						return h('span', null, row.alarmSource === 1 ? '设备告警' : '系统告警')
					},
				},
				{
					key: 'state',
					name: '状态',
					render: (h, row) => {
						return h('span', {}, !isBlank(row.state) ? (row.state == 0 ? '停用' : '启用') : '--')
					},
				},
				{
					key: 'ops',
					name: '操作',
					width: 150,
					render: (h, row) => {
						return h(
							'span',
							{
								style: {
									color: '#4d6bff',
									cursor: 'pointer',
									'font-size': '14px',
								},
								on: {
									click: () => {
										Object.assign(this.ruleForm, row)
										this.dialogShow = true
									},
								},
							},
							'修改',
						)
					},
				},
			],
			dialogShow: false,
			ruleForm: {
				eventName: '',
				ruleDescription: '',
				comparisonValue: '',
				unitName: '',
				state: '',
				eventExpression: null,
			},
		}
	},
	watch: {
		tabData: {
			handler(val) {
				if (Object.keys(val).length > 0) {
					this.getVeeList()
				}
			},
			immediate: true,
		},
	},
	created() {},
	mounted() {},
	methods: {
		ruleRequired,
		isBlank,
		handleSubmitForm() {
			this.$refs.ruleForm.validate(async valid => {
				if (valid) {
					const params = { ...this.ruleForm, deviceId: this.tabData.deviceId }
					if (this.ruleForm.alarmSource === 2 && !this.ruleForm.comparisonName) {
						const data = await this.$refs.alarmConfigRule.validate()
						if (!data && this.ruleForm.state === '1') return this.$message.warning('请先添加告警规则')
						params.eventExpression = data ? JSON.stringify(data) : null
					}
					await apiSetVeeRuleConfig(params)
					this.$message.success('修改成功！')
					this.dialogShow = false
					this.getVeeList()
				}
			})
		},
		handleCancel() {
			this.ruleForm = this.$options.data().ruleForm
			this.$nextTick(() => {
				this.$refs.ruleForm.resetFields()
				this.dialogShow = false
			})
		},
		getVeeList() {
			const { deviceId } = this.tabData
			apiGetVeeRuleConfig({
				deviceId,
			}).then(res => {
				this.tableData = res.records || []
			})
		},
	},
}
</script>
<style lang="scss" scoped>
.vee-table {
	height: 100%;
}
</style>
